/**
 * Homepage section tracking for GA4.
 * Tracks clicks on three contested sections:
 * - shop_by_type (navbar category nav)
 * - category_collage (shop by category)
 * - featured_products (crafted to shine tabs + products)
 */
(function () {
  'use strict';

  function track(section, target, extra) {
    try {
      if (typeof gtag !== 'function') return;
      var params = Object.assign({ section: section, target: target }, extra || {});
      gtag('event', 'hp_section_click', params);
    } catch (e) { /* 静默失败 */ }
  }

  document.addEventListener('click', function (e) {
    if (typeof gtag !== 'function') return;
    var el = e.target.closest('a, button');
    if (!el) return;

    // 1. Navbar (shop_by_type) — .campaign-nav-bar__item
    var navItem = el.closest('.campaign-nav-bar__item');
    if (navItem) {
      var label = (navItem.querySelector('.campaign-nav-bar__label') || navItem).textContent.trim();
      track('shop_by_type', label, { link_url: navItem.href || '' });
      return;
    }

    // 2. Category Collage — .category-collage__card
    var collageCard = el.closest('.category-collage__card');
    if (collageCard) {
      var name = (collageCard.querySelector('.category-collage__name') || collageCard).textContent.trim();
      track('category_collage', name, { link_url: collageCard.href || '' });
      return;
    }

    // 3. Featured Products — tabs and product cards
    var section = el.closest('.section-featured-products');
    if (section) {
      // Tab switch
      var tabBtn = el.closest('.featured-products__tab');
      if (tabBtn) {
        track('featured_products', 'tab', { tab_name: tabBtn.textContent.trim() });
        return;
      }
      // Product card click
      var productCard = el.closest('.featured-products__card');
      if (productCard) {
        var productName = productCard.getAttribute('title') || '';
        var activeTab = section.querySelector('.featured-products__tab.active');
        track('featured_products', 'product', {
          product_name: productName,
          tab: activeTab ? activeTab.textContent.trim() : ''
        });
        return;
      }
    }
  });
})();
